import { useMutation } from 'react-query';

import { CampaignCountryLanguageUpdate } from './insightsTypes';
import { api } from './swaggerApi';

export const useUpdateCampaignCountryLanguage = (
  campaignIdentifier: string
) => {
  return useMutation(async (data: CampaignCountryLanguageUpdate) => {
    return await api.insightsPlatform.campaignsUpdateCountryLanguagePartialUpdate(
      campaignIdentifier,
      data
    );
  });
};
